import { render, staticRenderFns } from "./azra_list.vue?vue&type=template&id=6d70d9df&scoped=true&"
import script from "./azra_list.vue?vue&type=script&lang=js&"
export * from "./azra_list.vue?vue&type=script&lang=js&"
import style0 from "./azra_list.vue?vue&type=style&index=0&id=6d70d9df&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d70d9df",
  null
  
)

export default component.exports